import {
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import axios from 'axios';
import { DriverEntity, DriverRequestEntity } from 'src/entities/driverEntity';

const getDriver = (id: number) => async () => {
  const res = await axios.get<DriverEntity>(`/api/v2/drivers/${id}`);
  return res.data;
};

export const useQueryDriver = (id: number) => useQuery(['drivers', { id }], getDriver(id), {
  staleTime: Infinity,
  enabled: Boolean(id)
});

export const useMutationDriver = () => {
  const queryClient = useQueryClient();
  return {
    addDriver: useMutation(
      (driver: DriverRequestEntity) => axios.post('/api/v2/drivers', driver),
      {
        onSuccess: () => queryClient.invalidateQueries(['drivers']),
      }
    ),
    updateDriver: useMutation(
      (driver: DriverEntity) => axios.put(`/api/v2/drivers/${driver.id}`, driver),
      {
        onSuccess: () => queryClient.invalidateQueries(['drivers']),
      }
    ),
    deleteDrivers: useMutation(
      (ids: number[]) => axios.delete('/api/v2/drivers/bulk', { data: { ids } }),
      {
        onSuccess: () => queryClient.invalidateQueries(['drivers']),
      }
    ),
  };
};
